module.exports = __webpack_public_path__ + "images/accents/accent-kiwis@1x-e9704cf27780511e9936e9179b13868d.webp";